import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=563c9c56&scoped=true"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=563c9c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c9c56",
  null
  
)

export default component.exports